// common
export const GET_OPENID = 'GET_OPENID' // 得到openid
export const GET_USERID = 'GET_USERID' // 得到userid
export const SET_CITYID = 'SET_CITYID' // 设置cityId
export const GET_FLAG = 'GET_FLAG' // 得到flag
export const GET_MARKETINFO = 'GET_MARKETINFO' // 项目信息
export const GET_MARKETLIST = 'GET_MARKETLIST' // 项目列表
export const GET_USERINFOR = 'GET_USERINFOR' // 得到用户信息
export const UPDATE_DIRECTION = 'UPDATE_DIRECTION' // 页面跳转方向
export const GET_THEME = 'GET_THEME' // 得到主题
export const GET_goindex = "GET_goindex"; //路由长度
export const GET_HolidayStyle = "GET_HolidayStyle"; // 节假日主题
export const GET_USERTENANTINFO = 'GET_USERTENANTINFO' // 得到用户默认企业信息
export const GET_USERTENANTINFOLIST = 'GET_USERTENANTINFOLIST' // 得到用户认证企业列表
export const HASTSMODULE = 'HASTSMODULE' // 是否有投诉建议模块

// 首页
export const GET_BANNERLIST = 'GET_BANNERLIST' // 得到首页轮播图
export const GET_ACTIVITYLIST = 'GET_ACTIVITYLIST' // 得到活动列表
export const GET_COMPANYWALLLIST = 'GET_COMPANYWALLLIST' // 得到企业墙列表
export const GET_EMPTYSHOPLIST = 'GET_EMPTYSHOPLIST' // 得到空铺列表
export const GET_SHOPSLIST = 'GET_SHOPSLIST' // 得到空铺列表
export const GET_NOTICELIST = 'GET_NOTICELIST' // 得到公告消息列表
export const GET_INDEXSTYLE = 'GET_INDEXSTYLE' // 得到首页tab

// 新办公
export const MEETINGUSETIME = 'MEETINGUSETIME' // 会议室使用次数
export const GETTEAMREPORT = 'GETTEAMREPORT' // 员工人员统计

//发现页
export const GETACTIVELIST = 'GETACTIVELIST' // 活动列表
export const GETWALLLIST = 'GETWALLLIST' // 企业墙列表

// 我的页面
export const MYHEADERDATE = 'MYHEADERDATE' // 头部数据